import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { SharedService } from "../../services/shared.service";
import { TokenStorageService } from "../../services/token-storage.service";
import { UserAuthService } from "../../services/user-auth.service";
import { OtpValidationService } from "../../services/otp-validation.service";
import { DisbursementSessionService} from "../../services/disbursement-session.service";

import { IBrandProfile } from '../../interfaces/brand-profile';
// import { IAuthToken } from '../../interfaces/auth-token';
import { IPageContent } from '../../interfaces/page-content';
// import { ValidationStatus } from '../../enums/validation-status';
import { IDestinationOption } from '../../interfaces/destination-option';

@Component({
  selector: 'app-otp-verification',
  // standalone: true,
  // imports: [],
  templateUrl: './otp-verification.component.html',
  styleUrl: './otp-verification.component.css'
})
export class OtpVerificationComponent implements OnInit {

  @ViewChild('ngOtpInput', { static: false}) ngOtpInput: any;


  private fb = inject(FormBuilder);
  private router = inject(Router);
  private sharedService = inject(SharedService);
  private tokenStorageService = inject(TokenStorageService);
  private userAuthService = inject(UserAuthService);
  private otpValidationService = inject(OtpValidationService);
  private disbursementSessionService = inject(DisbursementSessionService);

  otpTitle!: string | undefined;
  otpSubtitle!: string | undefined;
  otpPrompt!: string | undefined;
  otpWarning!: string | undefined;
  otpRequest!: string | undefined;

  optionSendText!: string | undefined;
  optionPhoneCall!: string | undefined;
  optionSendEmail!: string | undefined;

  singleDestinationOption!: string;
  chosenDestinationOption!: string;

  isStepOneShown: boolean = false;
  isStepTwoShown: boolean = false;

  isOtpTitleShown: boolean = false;
  isOtpSubtitleShown: boolean = false;
  isOtpPromptShown: boolean = false;
  isOtpWarningShown: boolean = false;
  isOtpRequestShown: boolean = false;
  isCancelLinkShown: boolean = false;

  isOptionSendTextShown: boolean = false;
  isOptionPhoneCallShown: boolean = false;
  isOptionSendEmailShown: boolean = false;

  hasOnlyOneDestinationOption: boolean = false;

  envRegion!: string;
  sessionId!: string;
  otpSessionId!: string;

  brandStyleTheme: any = {};
  ovForm!: FormGroup;
  // otpSendMethods: Map<string,string>;

  brandProfile!: IBrandProfile;
  pageContent!: IPageContent;
  isLogoutVisible: boolean = false;

  showErrorMessage: boolean = false;
  errorMessage!: string;

  otpDestinationOptions!: IDestinationOption[];

  isSpinnerShown: boolean = false;

  public constructor() {
      this.ovForm = this.fb.group({
        'otpDestinationId': new FormControl(null, [Validators.required]),
      });
    }

  ngOnInit(): void {
    this.envRegion = this.sharedService.getEnvRegion();
    this.sessionId = this.sharedService.getDsbSessionGuid();
    this.brandProfile = this.sharedService.getBrandProfile();
    // this.isStepOneShown = true;

    this.initPage();
  }

  initPage() {
    this.isStepOneShown = false;
    this.isStepTwoShown = false;
    this.isOtpRequestShown = false;
    this.otpSessionId = this.tokenStorageService.getOtpSessionId() || '';
    if (!this.otpSessionId) {
      // go to error page
    }

    this.otpTitle = this.sharedService.getConfigPropertyByName("OTP_VERIFICATION_TITLE") || 'Verify Your Identity';
    this.otpSubtitle = this.sharedService.getConfigPropertyByName("OTP_VERIFICATION_SEND_METHOD") || 'How would you like to receive it?';
    this.isOtpTitleShown = !(this.otpTitle == undefined);
    this.isOtpSubtitleShown = !(this.otpSubtitle == undefined);

    // Find out OTP destination options
    this.otpDestinationOptions = this.tokenStorageService.getDestinationOptions();
    console.log('this.otpDestinationOptions', this.otpDestinationOptions);
    if (this.otpDestinationOptions) {
      switch (this.otpDestinationOptions.length) {
        case 0:
          // what do we do if no destination options specified?
          break;
        case 1: 
          this.hasOnlyOneDestinationOption = true;
          this.singleDestinationOption = this.otpDestinationOptions[0].otpDestinationId;
          this.chosenDestinationOption = this.otpDestinationOptions[0].maskedAddressOrNumber;
          this.ovForm.get('otpDestinationId')?.setValue(this.singleDestinationOption); 
          this.requestOtpGeneration(this.singleDestinationOption);
          break;
        default:
          this.hasOnlyOneDestinationOption = false;
          this.isStepOneShown = true;
          break;
      }
    } else {
      this.errorMessage = 'Unable to determine contact destinations';
      this.showErrorMessage = true;
    }
  }

  // When the user clicks on a radio button to chose a destination
  onOptionChange(option: string) { 
    this.ovForm.get('otpDestinationId')?.setValue(option); 
    this.chosenDestinationOption = this.otpDestinationOptions.find(item => item.otpDestinationId === option)?.maskedAddressOrNumber || '';
  }

  // When the user has chosen a destination and requests an OTP
  onOtpGenerationSubmit() {
    let otpDestinationId = this.ovForm.get('otpDestinationId')?.value;
    this.requestOtpGeneration(otpDestinationId);
  }

  // Make a call into Auth Server to generate OTP and send it out to the chosen destination
  requestOtpGeneration(otpDestinationId: string) {
    this.isSpinnerShown = true;    
    this.otpValidationService.otpGenerate(otpDestinationId)
    .subscribe({
      next: () => {
        this.isStepOneShown = false;
        this.otpTitle = this.sharedService.getConfigPropertyByName("OTP_VERIFICATION_TITLE") || 'Verify Your Identity';
        this.otpSubtitle = (this.sharedService.getConfigPropertyByName("OTP_VERIFICATION_SEND_METHOD") || 'The verification code was sent to ')
           + this.chosenDestinationOption;
        this.otpPrompt = this.sharedService.getConfigPropertyByName("OTP_VERIFICATION_PROMPT") || 'Enter Authorization Code';
        this.otpWarning = this.sharedService.getConfigPropertyByName("OTP_VERIFICATION_WARNING") || 'The code expires 10 minutes after you requested it';
        this.otpRequest = this.sharedService.getConfigPropertyByName("OTP_VERIFICATION_REQUEST") || 'Request another authorization code';
        this.isOtpSubtitleShown = !(this.otpSubtitle == undefined);
        this.isOtpPromptShown = !(this.otpPrompt == undefined);
        this.isOtpWarningShown = !(this.otpWarning == undefined);
        this.isOtpRequestShown = !(this.otpRequest == undefined);
        this.isStepTwoShown = true;
      },
      error: (error) => {
        console.log('requestOtpGeneration',error);
        this.errorMessage = 'Unable to generate the OTP code';
        this.showErrorMessage = true;
      },
      complete: () => {
        this.isSpinnerShown = false;
      }
    });
  }  

  onCancel() {
    this.router.navigate(['/cv-comp']);
  }

  // When the user enters in the OTP code in the boxes - proceed to OTP validation after all the boxes have entries
  onOtpChange(otp: string) {
    console.log('otp', otp);
    if (otp && otp.length == 6) {
      this.showErrorMessage = false;
      // console.log('onSeonOtpChangendCode', this.otpSessionId);
      this.otpValidationService.otpVerify(otp)
      .subscribe({
        next: (response) => {
          console.log('onOtpChange - response', response);
          if (!response) {
            this.errorMessage = 'Unable to verify the entered code';
            this.showErrorMessage = true;
          }
          else {
            switch (response.code) {
              case 'OTP_VER_ERROR':
                this.ngOtpInput.setValue(null);
                this.ngOtpInput.focusTo(this.ngOtpInput.getBoxId(0));
                this.errorMessage = 'Unable to verify the entered code';
                this.showErrorMessage = true;
                break;
              case 'LOCKED':
                this.errorMessage = 'You have reached the maximum number of retries';
                this.showErrorMessage = true;
                this.isStepTwoShown = false;
                this.isCancelLinkShown = true;
                this.isOtpRequestShown = false;
                break;
              case 'FAILED':
                this.ngOtpInput.setValue(null);
                this.ngOtpInput.focusTo(this.ngOtpInput.getBoxId(0));
                this.errorMessage = 'Incorrect authorization code. Please enter the correct authorization code.';
                this.showErrorMessage = true;
                break;
              case 'VERIFIED':
                // Save off the auth token
                let tokenString: string = response.payload || '';
                console.log('validateCustomer - tokenString', tokenString);
                if (tokenString) {
                  this.tokenStorageService.setAuthToken(tokenString);
                  // Find out full user's privileges from the "permanent" token, then redirect to the next page
                  this.findUserPrivileges();
                } else {
                  console.log('validateCustomer', 'Verified user received empty token');
                  this.errorMessage = 'Unable to verify the entered code';
                  this.showErrorMessage = true;
                }
                break;
            }
          }
        },
        error: (error) => {
          console.log('validateCustomer',error);
          this.errorMessage = 'Unable to verify the entered code';
          this.showErrorMessage = true;
      },
        complete: () => {
        }
      });
    }
  }

  // When the user clicks on 'Resend Auth Code'
  // Make a call into Auth Server to generate a "renew" OTP auth token (almost a clone from the original)
  onResendAuthCode() {
    this.isSpinnerShown = true;    
    this.showErrorMessage = false;
    this.ngOtpInput.setValue(null);
    const elemId = this.ngOtpInput.getBoxId(0);
    this.ngOtpInput.focusTo(elemId);
    this.otpValidationService.otpAuthTokenRenew()
    .subscribe({
      next: (response) => {
        // Obtain a new OTP auth token
        let tokenString: string = response.accessToken;
        this.tokenStorageService.setAuthToken(tokenString);
        this.initPage();
      },
      error: (error) => {
        console.log('requestOtpTokenRenew', error);
        this.errorMessage = 'Unable to generate another OTP code';
        this.showErrorMessage = true;
      },
      complete: () => {
        this.isSpinnerShown = false;
      }
    });
  }  


  // Find out user's privileges and save them off, then redirect to the next page
  private findUserPrivileges() {
    this.isSpinnerShown = true;
    this.userAuthService.findUserPrivileges()
    .subscribe({
      next: (response) => {
        if (response) {
          console.log('otp-verification.findUserPrivileges',response);
          // Cache user privileges in the local storage
          this.tokenStorageService.setUserPrivileges(response);
          // Navigate to Disbursement Profile page
          // this.router.navigate(['/dsb-ocr']);
          // Obtain a SDK token
          this.getDisbursementSession();
        }
      },
      error: (error) => {
        console.log('findUserPrivileges',error);
      },
      complete: () => {
        this.isSpinnerShown = false;
      }
    });
  }

  // It used to retrieve a disbursements session, including a SDK token, at the beginning of the CP page
  // Now we are going to do it at the end of the OTP page when the customer successfully passes all validations
  private getDisbursementSession() {
    this.isSpinnerShown = true;
    console.log('getDisbursementSession - envRegion', this.envRegion);
    console.log('getDisbursementSession - sessionId', this.sessionId);
    this.disbursementSessionService.getDisbursementSession(this.envRegion, this.sessionId)
    .subscribe({
      next: (response) => {
        console.log('getDisbursementSession - response', response);
        if (response) {
          let disbursementSession = response;
          this.sharedService.setDisbursementSession(disbursementSession);
          // Navigate to Disbursement Profile page
          this.router.navigate(['/dsb-ocr']);
        }
      },
      error: (error) => {
        console.log('getDisbursementSession - error', error);
        this.errorMessage = 'Unable to establish a session for disbursements';
        this.showErrorMessage = true;
      },
      complete: () => {
        this.isSpinnerShown = false;
      }
    });
  }

}
